/** @jsxImportSource @emotion/react */
import React from 'react';
import { Form, Input, Modal, Select, Typography } from 'antd';
import type { FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import commonStyles from '../../styles/commonStyles';

interface EditAttributeValueModalProps {
  open: boolean;
  onOk: () => Promise<void>;
  onCancel: () => void;
  form: FormInstance;
  loading?: boolean;
  attribute: any;
}

export const EditAttributeValueModal: React.FC<EditAttributeValueModalProps> = ({
  open,
  onOk,
  onCancel,
  form,
  loading,
  attribute,
}) => {
  const { t } = useTranslation('crops');
  const hasOptions = attribute && Array.isArray(attribute.options) && attribute.options.length > 0;

  return (
    <Modal
      title={t('details.editValueModal.title', { name: attribute?.name ?? '' })}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={t('common:actions.save')}
      cancelText={t('common:actions.cancel')}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        {hasOptions ? (
          <Form.Item
            label={t('details.value')}
            name={['value', 'choiceId']}
          >
            <Select
              placeholder={t('details.selectValue')}
              allowClear
              optionFilterProp="label"
              options={attribute.options.map((option: any) => ({
                value: String(option.id),
                label: option.code && option.code !== option.title
                  ? `${option.title} (${option.code})`
                  : option.title,
              }))}
            />
          </Form.Item>
        ) : (
          <Form.Item
            label={t('details.value')}
            name={['value', 'customValue']}
          >
            <Input placeholder={t('details.enterValue')} allowClear />
          </Form.Item>
        )}
        {attribute?.description && (
          <Typography.Text type="secondary" css={commonStyles.smallText}>
            {attribute.description}
          </Typography.Text>
        )}
      </Form>
    </Modal>
  );
};
